module.exports = __webpack_public_path__ + "img/_cross-resonance-dagger_.c913d9c1.svg";